import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBasketball20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconBasketball20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.25 10.75v6.713a7.47 7.47 0 0 1-4.257-1.879 9.7 9.7 0 0 0 1.729-4.834zm1.5 0v6.713a7.47 7.47 0 0 0 4.257-1.879 9.7 9.7 0 0 1-1.729-4.834zm2.528-1.5H10.75V2.537a7.47 7.47 0 0 1 4.257 1.879 9.7 9.7 0 0 0-1.729 4.834m1.506 1.5a8.2 8.2 0 0 0 1.261 3.69 7.46 7.46 0 0 0 1.418-3.69zm2.679-1.5h-2.68a8.2 8.2 0 0 1 1.262-3.69 7.46 7.46 0 0 1 1.418 3.69m-8.213 0H6.722a9.7 9.7 0 0 0-1.729-4.834A7.47 7.47 0 0 1 9.25 2.537zm-4.034 0a8.2 8.2 0 0 0-1.261-3.69 7.46 7.46 0 0 0-1.418 3.69zm-2.679 1.5a7.46 7.46 0 0 0 1.418 3.69 8.2 8.2 0 0 0 1.261-3.69zm.962 5.473A8.97 8.97 0 0 0 10 19a8.97 8.97 0 0 0 6.502-2.777l.54-.517-.044-.046A8.96 8.96 0 0 0 19 10c0-2.145-.75-4.114-2.002-5.66l.044-.046-.544-.52A8.97 8.97 0 0 0 10 1a8.97 8.97 0 0 0-6.498 2.773l-.544.52.044.047A8.96 8.96 0 0 0 1 10c0 2.145.75 4.114 2.002 5.66l-.044.046z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconBasketball20);
